module.exports = __webpack_public_path__ + "img/zaitaorenyuanduibi.f92cf9d3.png";